export default __webpack_public_path__ + "static/media/pictogramBeaconUtilities40.49285438.svg";